import JobBulletList from "./JobBulletList";

const JobGroup = ({ group }) => {
  if (!group) return null;

  return (
    <div className="job-group">
      {group.title && <h5 className="job-group-title">{group.title}</h5>}

      <JobBulletList items={group.items} />
    </div>
  );
};

export default JobGroup;
